// src/pages/CampaignDetails.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { decodeId } from '../../../utills/idUtils';
import RespondentsTable from './RespondentsTable';
import Pagination from '../Pagination';
import { ArrowLeft } from 'lucide-react'; // Optional: icon for better UX
import BasicBreadcrumbs from '../../common/Breadcrumbs';

const API_URL = process.env.REACT_APP_API_URL;

const formatDate = (isoDate) => {
    if (!isoDate) return '-';
    const date = new Date(isoDate);
    return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    });
};

const CampaignDetails = () => {
    const { campaignId: encodedId } = useParams();
    const navigate = useNavigate();
    const campaignId = decodeId(encodedId);

    const [campaign, setCampaign] = useState(null);
    const [respondents, setRespondents] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [totalPages, setTotalPages] = useState(0);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchDetails = async () => {
            setLoading(true);
            setError('');
            try {
                const res = await axios.get(`${API_URL}/asmt/${campaignId}/details`, {
                    params: {
                        page: currentPage,
                        limit: rowsPerPage,
                    },
                });
                setCampaign(res.data.campaign);
                setRespondents(res.data.respondents);
                setTotalPages(res.data.totalPages || 0);
            } catch (err) {
                console.error("Error fetching campaign details:", err);
                setError(
                    err.response?.data?.message ||
                    "Something went wrong while fetching campaign details."
                );
            } finally {
                setLoading(false);
            }
        };

        fetchDetails();
    }, [campaignId, currentPage, rowsPerPage]);

    return (
        <div className="space-y-6 min-h-screen bg-blue-50 p-4 md:p-8">
            {/* {error && <button
                onClick={() => navigate(-1)}
                className="mb-4 flex items-center gap-2 text-blue-700 hover:text-blue-900 font-medium"
            >
                <ArrowLeft className="w-4 h-4" /> Go Back
            </button>} */}
{/* 
            {loading ? (
                <div className="text-center py-10 text-blue-700 font-medium">Loading campaign details...</div>
            ) : error ? (
                <div className="overflow-x-auto rounded shadow bg-white">
                    <table className="w-full border-collapse">
                        <thead>
                            <tr className="bg-blue-100">
                                <th className="p-3 text-left text-blue-700">Campaign ID</th>
                                <th className="p-3 text-left text-blue-700">Initiated On</th>
                                <th className="p-3 text-left text-blue-700">Type</th>
                                <th className="p-3 text-left text-blue-700"># Participants</th>
                                <th className="p-3 text-left text-blue-700"># Completed</th>
                                <th className="p-3 text-left text-blue-700">Status</th>
                                <th className="p-3 text-left text-blue-700">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                                <tr>
                                    <td colSpan="7" className="text-center text-gray-500 p-4">
                                        No campaigns found
                                    </td>
                                </tr>
                        </tbody>
                    </table>
                </div>
            ) : campaign ? (
                <div className="bg-white shadow-md rounded-lg p-6">
                    <BasicBreadcrumbs name={campaign.initiator_name} />
                    <div className="bg-white shadow-md p-6 rounded-lg">
                        <h2 className="text-xl  text-blue-800 mb-2" style={{ fontFamily: 'Poppins' }}>
                            Initiator: {campaign.initiator_name} ({campaign.initiator_email})
                        </h2>
                        <p className="text-gray-700 font-normal">
                            Campaign: {campaign.id} | Invite Sent On: {formatDate(campaign.initiated_on)}
                        </p>
                    </div>

                    <RespondentsTable respondents={respondents} />

                    {totalPages >= 1 && (
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            rowsPerPage={rowsPerPage}
                            onPageChange={(page) => setCurrentPage(page)}
                            onRowsPerPageChange={(rows) => {
                                setRowsPerPage(rows);
                                setCurrentPage(1); // Reset to page 1 when rows change
                            }}
                        />
                    )}
                </div>
            ) : (
                    <div className="overflow-x-auto rounded shadow bg-white">
                    <table className="w-full border-collapse">
                        <thead>
                            <tr className="bg-blue-100">
                                <th className="p-3 text-left text-blue-700">Campaign ID</th>
                                <th className="p-3 text-left text-blue-700">Initiated On</th>
                                <th className="p-3 text-left text-blue-700">Type</th>
                                <th className="p-3 text-left text-blue-700"># Participants</th>
                                <th className="p-3 text-left text-blue-700"># Completed</th>
                                <th className="p-3 text-left text-blue-700">Status</th>
                                <th className="p-3 text-left text-blue-700">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                                <tr>
                                    <td colSpan="7" className="text-center text-gray-500 p-4">
                                        No campaigns found
                                    </td>
                                </tr>
                        </tbody>
                    </table>
                </div>
            )} */}


            {
                loading ?  <div className="text-center py-10 text-blue-700 font-medium">Loading campaign details...</div> : (
                    campaign ?  <div className="bg-white shadow-md rounded-lg p-6">
                    <BasicBreadcrumbs name={campaign.initiator_name} />
                    <div className="bg-white shadow-md p-6 rounded-lg">
                        <h2 className="text-xl  text-blue-800 mb-2" style={{ fontFamily: 'Poppins' }}>
                            Initiator: {campaign.initiator_name} ({campaign.initiator_email})
                        </h2>
                        <p className="text-gray-700 font-normal">
                            Campaign: {campaign.id} | Invite Sent On: {formatDate(campaign.initiated_on)}
                        </p>
                    </div>

                    <RespondentsTable respondents={respondents} />

                    {totalPages >= 1 && (
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            rowsPerPage={rowsPerPage}
                            onPageChange={(page) => setCurrentPage(page)}
                            onRowsPerPageChange={(rows) => {
                                setRowsPerPage(rows);
                                setCurrentPage(1); // Reset to page 1 when rows change
                            }}
                        />
                    )}
                </div> : (
                    <div className="bg-white shadow-md rounded-lg p-6">
                    <BasicBreadcrumbs name={""} />
                      <div className="overflow-x-auto rounded shadow-md bg-white p-6">
                    <table className="w-full border-collapse">
                        <thead>
                            <tr className="bg-blue-100">
                                <th className="p-3 text-left text-blue-700">Campaign ID</th>
                                <th className="p-3 text-left text-blue-700">Initiated On</th>
                                <th className="p-3 text-left text-blue-700">Type</th>
                                <th className="p-3 text-left text-blue-700"># Participants</th>
                                <th className="p-3 text-left text-blue-700"># Completed</th>
                                <th className="p-3 text-left text-blue-700">Status</th>
                                <th className="p-3 text-left text-blue-700">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                                <tr>
                                    <td colSpan="7" className="text-center text-gray-500 p-4">
                                        No campaigns found
                                    </td>
                                </tr>
                        </tbody>
                    </table>
                </div>
                 </div>
                )
                )
            }
        </div>
    );
};

export default CampaignDetails;
